import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		inpage: {
			contentBlockLabel: "External code",
			titleInputLabel: "External code title (internal)",
			brandSelectorLabel: "Brand",
			editInpageWidget: "Edit",
			newInpageWidget: "New external code",
			messageDeleteInpageWidget: "Delete external code",
			messageDeleteInpageWidgetTitle: "Are you sure you want to delete the external code?",
			deleteInpageWidget: "Delete",
			messageDeleted: "External code deleted",
			errorOnDeleting: "Error deleting the external code",
			errorFailedLoadedDatawrapperWithId: "Error getting the external code",
			select: "Select external code"
		},
		inpageList: {
			newButton: "New external code",
			search: "Search for external code title (internal)",
			provider: "Provider",
			license: "License",
			title: "Widget title (internal)",
			deleteInpageWidget: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading external code",
			description: "Description",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createInpageWidget: "Create external code",
			allBrands: "All brands"
		},
		inpageEdit: {
			title: "External code title (internal)",
			preview: "Preview",
			provider: "Provider",
			html: "Source code",
			consent: "Needs consent",
			adLabel: "Mark as ad",
			markAffiliate: "Mark as affiliate",
			license: "License",
			editInpageWidgetButton: "External code",
			messageSaved: "The changes have been saved. To display the external code in an article, add it to the desired article.",
			messageSaveFailed: "The external code was not saved.",
			showPreview: "Show preview",
			hidePreview: "Collapse preview",
			validate: "Validate & show preview",
			invalidHtml: "The widget source code validation was not successful.",
			validHtml: "The widget source code validation was successful!",
			url: "Tennisnet URL",
			invalidUrl: "The Tennisnet URL validation was not successful!",
			validUrl: "The Tennisnet URL validation was successful!",
			dcaUrl: "Embed URL (Dynamic Content Agent)",
			dcaInvalidUrl: "The embed URL is not valid. Only {origin}/<contentId> is allowed.",
			dcaBrandMismatch: "The content belongs to the DCA brand \"{brand}\" and does not match the license of this widget.",
			dcaMeta: {
				notPublished: "The content is not published in the Dynamic Content Agent.",
				unreachable: "The Dynamic Content Agent is not reachable. Please try again.",
				invalid: "The Dynamic Content Agent returned invalid metadata for this content."
			},
			dcaPicker: {
				search: "Search for title or content ID",
				placement: "Type",
				placementArticle: "Calculator",
				placementHome: "Home widget",
				brand: "Brand",
				all: "All",
				refresh: "Refresh list",
				loading: "Loading live content",
				error: "Error loading the list. The embed URL can be entered directly below.",
				emptyCatalog: "No live content",
				noMatches: "No content matches the filters.",
				notInCatalog: "The selected content is not live or no longer published."
			}
		}
	},
	de: {
		inpage: {
			contentBlockLabel: "Externer Code",
			titleInputLabel: "Externer-Code-Titel",
			brandSelectorLabel: "Marke",
			editInpageWidget: "Bearbeiten",
			newInpageWidget: "Neuer Externer Code",
			messageDeleteInpageWidget: "Externen Code löschen",
			messageDeleteInpageWidgetTitle: "Willst du den Externen Code wirklich löschen?",
			deleteInpageWidget: "Löschen",
			messageDeleted: "Externer Code gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Externen Codes",
			errorFailedLoadedDatawrapperWithId: "Fehler beim Laden des Externen Codes",
			select: "Externen Code auswählen"
		},
		inpageList: {
			newButton: "Neues Inpage-Widget",
			search: "Suchen nach Titel des Externen Codes oder -Anbieter",
			provider: "Anbieter",
			license: "Lizenz",
			title: "Externer-Code-Titel (intern)",
			deleteInpageWidget: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Externer Code wird geladen",
			description: "Beschreibung",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createInpageWidget: "Externen Code erstellen",
			allBrands: "Alle"
		},
		inpageEdit: {
			title: "Externer-Code-Titel (intern)",
			preview: "Vorschau",
			provider: "Anbieter",
			html: "Quellcode",
			consent: "Braucht Consent",
			adLabel: "Als Anzeige markieren",
			markAffiliate: "Als Affiliate markieren",
			license: "Lizenz",
			editInpageWidgetButton: "Externer Code",
			messageSaved: "Die Änderungen wurden gespeichert. Um den Externen Code in einem Artikel anzuzeigen, muss das Widget dort hinzugefügt werden.",
			messageSaveFailed: "Der Externe Code wurde nicht gespeichert.",
			showPreview: "Vorschau anzeigen",
			hidePreview: "Vorschau einklappen",
			validate: "Validieren & Vorschau anzeigen",
			invalidHtml: "Die Validierung des Widget-Quellcodes ist fehlgeschlagen.",
			validHtml: "Die Validierung des Widget-Quellcodes ist erfolgreich!",
			url: "Tennisnet-URL",
			invalidUrl: "Die Validierung der Tennisnet-URL ist fehlgeschlagen!",
			validUrl: "Die Validierung der Tennisnet-URL ist erfolgreich!",
			dcaUrl: "Embed-URL (Dynamic Content Agent)",
			dcaInvalidUrl: "Die Embed-URL ist ungültig. Erlaubt ist nur {origin}/<contentId>.",
			dcaBrandMismatch: "Der Inhalt gehört zur DCA-Marke „{brand}“ und passt nicht zur Lizenz dieses Widgets.",
			dcaMeta: {
				notPublished: "Der Inhalt ist im Dynamic Content Agent nicht veröffentlicht.",
				unreachable: "Der Dynamic Content Agent ist nicht erreichbar. Bitte erneut versuchen.",
				invalid: "Der Dynamic Content Agent hat für diesen Inhalt ungültige Metadaten geliefert."
			},
			dcaPicker: {
				search: "Suchen nach Titel oder Content-ID",
				placement: "Typ",
				placementArticle: "Rechner",
				placementHome: "Home-Widget",
				brand: "Marke",
				all: "Alle",
				refresh: "Liste aktualisieren",
				loading: "Live-Inhalte werden geladen",
				error: "Fehler beim Laden der Liste. Die Embed-URL kann unten direkt eingetragen werden.",
				emptyCatalog: "Keine live gestellten Inhalte",
				noMatches: "Keine Inhalte passen zu den Filtern.",
				notInCatalog: "Der gewählte Inhalt ist nicht live gestellt oder nicht mehr veröffentlicht."
			}
		}
	}
}, r = [{
	path: "/inpage",
	children: [
		{
			path: "",
			name: "inpage_list",
			component: () => import("./inpage-list.view-B4QpciG2.js").then((e) => e.n),
			meta: { requiredRight: "inpage-widgets:navigate" }
		},
		{
			path: "new",
			name: "inpage_new",
			component: () => import("./inpage-edit.view-mg4q1Jau.js").then((e) => e.n),
			props: () => ({
				title: t().t("inpage.newInpageWidget"),
				backRoute: "/inpage"
			}),
			meta: { requiredRight: ["inpage-widgets:navigate"] }
		},
		{
			path: ":id",
			name: "inpage_detail",
			component: () => import("./inpage-edit.view-mg4q1Jau.js").then((e) => e.n),
			props: (e) => ({
				title: t().t("inpageEdit.editInpageWidgetButton"),
				id: e.params.id,
				backRoute: "/inpage"
			}),
			meta: { requiredRight: ["inpage-widgets:navigate"] }
		}
	]
}], i = e(() => import("./inpage-article-block-BWJL04xc.js")), a = e(() => import("./inpage-channel-block-BUJEf-D0.js")), o = {
	messages: n,
	routes: r,
	contentBlocks: [{
		type: "INPAGE_WIDGET",
		label: "inpage.contentBlockLabel",
		icon: "file-text",
		component: i,
		defaultValue: { type: "INPAGE_WIDGET" }
	}]
};
//#endregion
export { a as ChannelInpageWidgetBlock, i as InpageWidgetContentBlock, o as inpageWidgetModule };

//# sourceMappingURL=index.es.js.map